module.exports = __webpack_public_path__ + "static/img/second.43c7cf6b.png";